import { render, staticRenderFns } from "./fenduan.vue?vue&type=template&id=92aa4d5c&scoped=true&"
import script from "./fenduan.vue?vue&type=script&lang=js&"
export * from "./fenduan.vue?vue&type=script&lang=js&"
import style0 from "./fenduan.vue?vue&type=style&index=0&id=92aa4d5c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92aa4d5c",
  null
  
)

export default component.exports